export default __webpack_public_path__ + "static/media/client_12.2844dcf2.png";